import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FocusOnFirstInvalidFieldModule } from '@go-modules/directives/focus-on-first-invalid-field';
import { VideoShareDialogComponent } from './video-share-dialog.component';
import { A11yModule } from '@angular/cdk/a11y';
import { UserFormFieldModule } from '@go-modules/components/user-form-field/user-form-field.module';
import { CopyToClipboardDirectiveModule } from '@go-modules/directives/go-clipboard/copy-to-clipboard.module';
import { VideoReviewersComponent } from '@go-modules/components/video-reviewers/video-reviewers.component';
import { GoCdkPopoverDirective } from '@go-modules/directives/go-cdk-popover/go-cdk-popover.directive';
import { MatTooltipModule } from '@angular/material/tooltip';
import { GoDialogContentDirective } from '@go-modules/directives/go-dialog-content/go-dialog-content.directive';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		GoMaterialModule,
		FormsModule,
		ReactiveFormsModule,
		FocusOnFirstInvalidFieldModule,
		A11yModule,
		UserFormFieldModule,
		MatTooltipModule,
		CopyToClipboardDirectiveModule,
		VideoReviewersComponent,
		GoCdkPopoverDirective,
		GoDialogContentDirective
	],
	declarations: [
		VideoShareDialogComponent
	],
	exports: [
		VideoShareDialogComponent
	]
})
export class VideoShareDialogModule {}
